import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { useEffect, useRef } from "react";
import { PalletSection } from "../../interfaces/intakes.reports";
import { colorsArray } from "../../helpers/colorsArray";
import { pallgrowDefects } from "../../helpers/defectsTable";

ChartJS.register(ArcElement, Tooltip);

interface Props {
    palletId: string;
    pallgrow: PalletSection;
    chartIndex: number;
    onReady: (id: string, index: number, img: string) => void;
}

ChartJS.register(ArcElement, Tooltip, Legend);
export const PDFDonutDefects = ({ palletId, pallgrow, chartIndex, onReady }: Props) => {
    const ref = useRef<any>();

    const { major, minor } = pallgrowDefects(pallgrow.data, (pallgrow.major || []), (pallgrow.minor || []))

    const pallgrownMM = [...major, ...minor];

    let labels = []
    let dataFinal = []

    for (let item of pallgrownMM) {
        labels.push(item.label)
        dataFinal.push(item.value)
    }

    let colors = colorsArray.slice(0, (pallgrownMM.length)) || ["#d6534c"]

    const chartdata = {
        labels: labels || "No Data",
        datasets: [
            {
                label: "Markets Monitored",
                data: dataFinal || 0,
                backgroundColor: colors,
                borderColor: colors,
                borderWidth: 1,
            },
        ],
    };

    useEffect(() => {
        if (!pallgrownMM.length) return;

        const timer = setTimeout(() => {
            if (!ref.current) return;

            const img = ref.current.toBase64Image();
            onReady(palletId, chartIndex, img);

        }, 1000);

        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="tw-fixed tw-opacity-0 tw-pointer-events-none">
            <Doughnut
                ref={ref}
                options={{
                    plugins: {
                        legend: {
                            position: 'bottom',
                        },
                    },
                }}
                data={chartdata}
            />
        </div>
    );
};
